import Vue from "vue";
export var JobEventBus = new Vue();